import { render, staticRenderFns } from "./CalculationQueue.vue?vue&type=template&id=2008a9b4"
import script from "./CalculationQueue.vue?vue&type=script&lang=js"
export * from "./CalculationQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports